/* eslint-disable @typescript-eslint/no-shadow */
import { Spacing16, Spacing32, Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductListItemModel } from 'autogen/swagger/all';
import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables/breakpoint';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import HorizontalProductItem from '../HorizontalProductItem';

const Column = styled.div`
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    row-gap: ${Spacing8};
`;

const scrollContainerCss = css`
    && {
        padding: 0 ${Spacing16};
        margin: 0 -${Spacing16};

        ${breakpoint.up(sizes.xl)} {
            padding: 0;
            margin: 0;
        }
    }
`;

const getColumns = <T,>(items: T[], maxItemsPerColumn: number) => {
    const columns: T[][] = [];
    let column: T[] = [];
    items.forEach((item, index) => {
        const currItemsInColumn = column.length;
        const lastItem = index === items.length - 1;

        if (currItemsInColumn === maxItemsPerColumn) {
            columns.push(column);
            column = [];
        }

        column.push(item);

        if (lastItem) {
            columns.push(column);
        }
    });

    return columns;
};

export default function HorizontalProductItemCarousel({
    items,
    maxItemsPerColumn = 3
}: {
    items: ProductListItemModel[];
    maxItemsPerColumn?: number;
}) {
    const columns = getColumns<ProductListItemModel>(items, maxItemsPerColumn);
    const itemsNum = items.length;
    const mobileIndentation = itemsNum > maxItemsPerColumn ? Spacing32 : '0px';

    return (
        <>
            <DynamicItemCarousel
                items={columns}
                itemSize={392}
                nextItemMobileIndentation={mobileIndentation}
                scrollContainerCss={scrollContainerCss}
                itemRenderer={(column, index) => (
                    <Column key={index}>
                        {column.map((item) => (
                            <HorizontalProductItem key={item.id} model={item} />
                        ))}
                    </Column>
                )}
            />
        </>
    );
}
